import { HomeTaskType } from '@/types/components';

export const thirdPartyTaskTypes: Record<string, HomeTaskType> = {
  soma: HomeTaskType.Soma,
  uzdevumi: HomeTaskType.Uzdevumi,
};
